import styles from "./styles.module.css";
export const Button = ({
  children = "",
  onClick = () => {},
  active = undefined,
  inactive = undefined,
  type="primary"
}) => (
  <div
  className={`${styles.button} ${styles[type]}`}
    onClick={onClick}
    data-isactive={active}
    data-isinactive={inactive}
  >
    {children}
  </div>
);
